// extracted by mini-css-extract-plugin
export default {"quick":"style_quick__7NYyz","sub-menu-wrap":"style_sub-menu-wrap__KSRhW","subMenu":"style_subMenu__WcNee"};